export interface AuthToken {
  accessToken: string;
  refreshToken: string;
  tokenType: string
  expiresIn: number;
  issuedTokenType: string;
  idToken: string;
  accessTokenTime: number;
}
